import React from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function NewUpdateTransactionFormToggleWrapper(
  props: {
    children: React.ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.NEW_UPDATE_TRANSACTION_FORM}>
      {props.children}
    </ToggleWrapper>
  );
}
